var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.6875C2.25 10.0662 2.75368 9.5625 3.375 9.5625H14.625C15.2463 9.5625 15.75 10.0662 15.75 10.6875V14.0625C15.75 14.6838 15.2463 15.1875 14.625 15.1875H3.375C2.75368 15.1875 2.25 14.6838 2.25 14.0625V10.6875ZM14.625 10.6875H3.375V14.0625H14.625V10.6875Z",
    fill: "#4B5C71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.9375C2.25 3.31618 2.75368 2.8125 3.375 2.8125H14.625C15.2463 2.8125 15.75 3.31618 15.75 3.9375V7.3125C15.75 7.93382 15.2463 8.4375 14.625 8.4375H3.375C2.75368 8.4375 2.25 7.93382 2.25 7.3125V3.9375ZM14.625 3.9375H3.375V7.3125H14.625V3.9375Z",
    fill: "#4B5C71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 6.46875C13.1222 6.46875 13.5 6.09099 13.5 5.625C13.5 5.15901 13.1222 4.78125 12.6562 4.78125C12.1903 4.78125 11.8125 5.15901 11.8125 5.625C11.8125 6.09099 12.1903 6.46875 12.6562 6.46875Z",
    fill: "#4B5C71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 13.2188C13.1222 13.2188 13.5 12.841 13.5 12.375C13.5 11.909 13.1222 11.5312 12.6562 11.5312C12.1903 11.5312 11.8125 11.909 11.8125 12.375C11.8125 12.841 12.1903 13.2188 12.6562 13.2188Z",
    fill: "#4B5C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterData);
export default __webpack_public_path__ + "static/media/MasterData.14f80dda4c72191d046c18b10a2bfafb.svg";
export { ForwardRef as ReactComponent };